import React from "react";
import { appColors, appType } from "../../utils/appTheme";
import AppCard from "./AppCard";
import Money from "./Money";
import Badge from "./Badge";
import AppButton from "./AppButton";

/**
 * Tarjeta hero de saldo (pantalla Home / Estado de cuenta).
 * label + badge de mora, monto grande, filas hairline (k/sub/valor) y par de botones 50/50.
 *
 * rows: [{ k, sub, v }]
 * primaryAction / secondaryAction: { label, onClick }
 */
const BalanceCard = ({
  label = "Saldo pendiente",
  amount,
  amountTone,
  moraLabel,
  rows = [],
  primaryAction,
  secondaryAction,
  style,
}) => (
  <AppCard variant="hero" padding={20} style={style}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
      }}
    >
      <span style={{ ...appType.bodySm, color: appColors.ink2 }}>{label}</span>
      {moraLabel && (
        <Badge tone="amber" dot>
          {moraLabel}
        </Badge>
      )}
    </div>

    <div style={{ margin: "10px 0 4px" }}>
      <Money value={amount} size={34} tone={amountTone} />
    </div>

    {rows.length > 0 && (
      <div style={{ marginTop: 14 }}>
        {rows.map((r, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 0",
              borderTop: `1px solid ${appColors.line2}`,
            }}
          >
            <span style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ ...appType.body, fontSize: 13 }}>{r.k}</span>
              {r.sub && <span style={{ ...appType.caption }}>{r.sub}</span>}
            </span>
            <span style={{ ...appType.body, fontSize: 15, fontVariantNumeric: "tabular-nums" }}>
              {r.v}
            </span>
          </div>
        ))}
      </div>
    )}

    {(primaryAction || secondaryAction) && (
      <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
        {primaryAction && (
          <AppButton variant="primary" block onClick={primaryAction.onClick}>
            {primaryAction.label}
          </AppButton>
        )}
        {secondaryAction && (
          <AppButton variant="outline" block onClick={secondaryAction.onClick}>
            {secondaryAction.label}
          </AppButton>
        )}
      </div>
    )}
  </AppCard>
);

export default BalanceCard;
